import get from 'lodash/get';
import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';
import PropTypes from 'prop-types';
import {useNavigate} from 'react-router-dom';

import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CaseIcon from '@mui/icons-material/WorkOutline';
import Tooltip from '@mui/material/Tooltip';

const ViewPatientCasesButton = props => {
  const {iconOnly, Icon} = props;
  const navigate = useNavigate();
  const patientId = (
    isString(props.patientId) || isNumber(props.patientId)
    ? props.patientId
    : get(props, 'patient.id')
  ) || '';
  const url = `/providers/cases?patient_id=${patientId}`;
  const onClick = () => navigate(url);
  const childProps = {
    onClick,
    disabled: !patientId,
    variant: iconOnly ? null : (props.variant || 'contained'),
    color: iconOnly ? 'primary' : undefined,
    startIcon: iconOnly ? null : (props.Icon ? <Icon/> : <CaseIcon/>),
    fullWidth: props.fullWidth || null,
  };
  return (
    iconOnly
    ? <Tooltip title='View Cases'>
      <IconButton {...childProps} sx={{padding: 0}}>
        {props.Icon ? <Icon/> : <CaseIcon/>}
      </IconButton>
    </Tooltip>
    : <Button {...childProps}>
      Cases
    </Button>
  );
};

ViewPatientCasesButton.defaultProps = {
  iconOnly: false,
};

ViewPatientCasesButton.propTypes = {
  patient: PropTypes.object,
  patientId: PropTypes.string, // either this or the patient
  iconOnly: PropTypes.bool,
};

export default ViewPatientCasesButton;
